import { NavbarNode } from 'app/shared/model/navbar_node.model';
import { TreeWrapperNode } from './tree-wrapper-node.model';

export interface ITreeOptions {
  actionMapping?: {
    mouse?: {
      click?: (tree: TreeModel, node: TreeWrapperNode, $event: MouseEvent) => void;
      contextMenu?: (tree: TreeModel, node: TreeWrapperNode, $event: MouseEvent) => void;
      [key: string]: any;
    };
  };
  allowDrag?: (node: TreeWrapperNode) => boolean;
  allowDrop?: (node: TreeWrapperNode) => boolean;
  animateExpand?: boolean;
  animateSpeed?: number;
}

export class TreeModel {
  roots: TreeWrapperNode[] = [];
  expandedNodeIds: { [key: string]: boolean } = {};
  options: ITreeOptions = {};
  
  private allNodesMap: Map<any, TreeWrapperNode> = new Map();

  constructor(nodes: NavbarNode[], options: ITreeOptions = {}) {
    this.options = options;
    this.setData(nodes);
  }

  setData(nodes: NavbarNode[]): void {
    this.roots = [];
    this.allNodesMap.clear();
    this.expandedNodeIds = {};

    if (nodes && nodes.length > 0) {
      this.roots = nodes.map((node, idx) => {
        const wrapperNode = new TreeWrapperNode(node, null, this);
        wrapperNode.index = idx;
        wrapperNode.level = 0;
        this.registerNode(wrapperNode);
        return wrapperNode;
      });
    }
  }

  private registerNode(node: TreeWrapperNode): void {
    this.allNodesMap.set(node.id, node);
    node.children.forEach(child => this.registerNode(child));
  }

  get nodes(): NavbarNode[] {
    return this.roots.map(root => root.data);
  }

  getNodeById(id: any): TreeWrapperNode | undefined {
    return this.allNodesMap.get(id);
  }

  getFirstRoot(): TreeWrapperNode | undefined {
    return this.roots.length > 0 ? this.roots[0] : undefined;
  }

  get expandedNodes(): TreeWrapperNode[] {
    return Array.from(this.allNodesMap.values()).filter(node => node.isExpanded);
  }

  setExpandedNode(node: TreeWrapperNode, isExpanded: boolean): void {
    this.expandedNodeIds[node.id] = isExpanded;
  }

  expandAll(): void {
    this.roots.forEach(root => root.expandAll());
  }

  collapseAll(): void {
    this.roots.forEach(root => root.collapseAll());
    this.expandedNodeIds = {};
  }

  isExpanded(node: TreeWrapperNode): boolean {
    return !!this.expandedNodeIds[node.id];
  }

  focusNode(node: TreeWrapperNode): void {
    // Desactivar todos los nodos
    this.allNodesMap.forEach(n => {
      n.isFocused = false;
      n.isActive = false;
    });
    
    // Activar el nodo seleccionado
    if (node) {
      node.isFocused = true;
      node.isActive = true;
    }
  }

  doForAll(fn: (node: TreeWrapperNode) => void): void {
    this.roots.forEach(root => this.doForAllRecursive(root, fn));
  }

  private doForAllRecursive(node: TreeWrapperNode, fn: (node: TreeWrapperNode) => void): void {
    fn(node);
    node.children.forEach(child => this.doForAllRecursive(child, fn));
  }
}

